import React, { Component } from 'react';
import Brand from '../../shared/brand/brand';
import ProjectBar from '../../shared/projectBar/projectBar';
import NavBar from '../../shared/navBar/navBar';
import ContractingUnitMainLayout from './contractingUnitMainLayout';

export interface State {
  redirect: boolean
}

export default class ContractingUnit extends Component<any, State> {
  constructor(props: {}) {
    super(props);
    this.state = { redirect: false };
  }

  render() {
    return (
      <div>
        <Brand/>
        <ProjectBar
          contractingUnit={this.props.currentUser && this.props.currentUser.contractingUnits[0] ? this.props.currentUser.contractingUnits[0] : null}/>
        <NavBar selectedKey={'/contracting-unit'} currentUser={this.props.currentUser}/>
        <ContractingUnitMainLayout/>
      </div>
    );
  }
}
